import { render } from "./breadcrumbMs.vue?vue&type=template&id=d1585852"
import script from "./breadcrumbMs.vue?vue&type=script&lang=js"
export * from "./breadcrumbMs.vue?vue&type=script&lang=js"

import "./breadcrumbMs.vue?vue&type=style&index=0&id=d1585852&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__